<template>
  <a-layout>
    <a-layout-sider
      :collapsed="isCollapsed"
      theme="light"
      collapsible
      class="left-sider"
      :width="240"
    >
      <a-menu
        :selected-keys="selectedKeys"
        :open-keys="openKeys"
        theme="light"
        mode="inline"
      >
        <a-menu-item
          key="MY_OKR"
          class="menu-item"
        >
          <template #icon>
            <IconFont type="iconwodeOKR" />
          </template>
          <router-link :to="{ name: 'MyOkr' }">
            {{ $t('layout.menu.myOkr') }}
          </router-link>
        </a-menu-item>
        <a-menu-item
          v-if="(subordinates && subordinates.length !== 0 )|| uid=== UID"
          id="my-team-weekly-btn"
          key="MY_TEAM_OKR_WEEK"
          class="menu-item"
        >
          <template #icon>
            <IconFont2 type="icon-fupanzongjie" />
          </template>
          <router-link :to="{ name: 'MyTeamOkrWeek', params: myTeamOkrWeekParams }">
            {{ $t('layout.menu.myTeamOkrWeek') }}
          </router-link>
        </a-menu-item>
        <a-sub-menu
          v-if="superiors && superiors.length !== 0"
          key="SUPERIORS"
        >
          <template #icon>
            <IconFont type="iconzhishushangji" />
          </template>
          <template #title>
            {{ $t('layout.menu.leaders') }}
          </template>
          <MenuItemAvatar
            v-for="superior in superiors"
            :key="superior.id"
            :user="superior"
          />
        </a-sub-menu>
        <a-sub-menu
          v-if="subordinates && subordinates.length !== 0"
          key="SUBORDINATES"
        >
          <template #icon>
            <IconFont type="iconzhishuxiaji" />
          </template>
          <template #title>
            {{ $t('layout.menu.subordinates') }}
          </template>
          <MenuItemAvatar
            v-for="subordinate in subordinates"
            :key="subordinate.id"
            :user="subordinate"
          />
        </a-sub-menu>
        <a-sub-menu key="FOLLOWINGS">
          <template #icon>
            <IconFont type="iconwodeguanzhu" />
          </template>
          <template #title>
            {{ $t('layout.menu.followings') }} ({{ followings ? followings.length : 0 }})
          </template>
          <MenuItemAvatar
            v-for="following in followings"
            :key="following.id"
            :user="following"
          />
        </a-sub-menu>
        <a-menu-item key="ALIGNMENT_MAP">
          <template #icon>
            <IconFont type="iconmubiaoditu" />
          </template>
          <router-link
            class="menu-item"
            :to="{ name: 'AlignmentMap' }"
          >
            {{ $t('layout.menu.alignmentMap') }}
          </router-link>
        </a-menu-item>
        <a-sub-menu
          v-if="isManager"
          key="STATISTICS"
        >
          <template #icon>
            <IconFont type="iconbaobiaozhuanqu" />
          </template>
          <template #title>
            {{ $t('layout.menu.report') }}
          </template>
          <a-menu-item key="SUMMARY">
            <router-link
              :to="{ name: 'Statistics' }"
            >
              {{ $t('layout.menu.reportOverview') }}
            </router-link>
          </a-menu-item>
          <a-menu-item key="DEPARTMENTS_CHART">
            <router-link
              :to="{ name: 'StatisticDepartment' }"
            >
              {{ $t('layout.menu.reportDepartment') }}
            </router-link>
          </a-menu-item>
        </a-sub-menu>
        <a-sub-menu
          id="my-team-okr"
          key="TEAM"
        >
          <template #icon>
            <!-- <IconFont type="iconwodetuandui" /> -->
            <IconFont2 type="icon-renyuanliebiao" />
          </template>
          <template #title>
            {{ $t('layout.menu.team') }}
          </template>
          <MyTeam />
        </a-sub-menu>
        <a-sub-menu
          v-if="isHrbp"
          id="my-department-tree"
          key="DEPARTMENT_TREE"
        >
          <template #icon>
            <IconFont type="iconwodetuandui" />
            <!-- <IconFont2 type="icon-fupanzongjie" /> -->
          </template>
          <template #title>
            {{ $t('layout.menu.departmentsSupported') }}
          </template>
          <DepartmentTree />
        </a-sub-menu>
      </a-menu>
      <a-button
        shape="circle"
        class="bg-btn collapse-btn"
        @click="toggleCollapsed()"
      >
        <template #icon>
          <IconFont
            :type="isCollapsed ? 'iconzhankai' : 'iconshouqi'"
            class="icon-block"
            :style="{ fontSize: '16px' }"
          />
        </template>
      </a-button>
    </a-layout-sider>
  </a-layout>
</template>

<script>
import { computed } from 'vue'
import { useStore } from 'vuex'

import { TOGGLE_SIDE_MENU_COLLAPSED } from '@/store/mutation-types'
import MenuItemAvatar from './MenuItemAvatar'
import DepartmentTree from './DepartmentTree'
import MyTeam from './MyTeam'
import { UID, TEAM_LEADER_UID } from '@/constants/my-team-weekly-custom.js'

export default {
  components: {
    MenuItemAvatar,
    DepartmentTree,
    MyTeam
  },
  setup () {
    const store = useStore()
    const selectedKeys = computed(() => store.state.menu.selectedKeys)
    const openKeys = computed(() => store.state.menu.openKeys)
    const isCollapsed = computed(() => store.state.app.isSideMenuCollapsed)

    const superiors = computed(() => store.state.user.managerUserIds)
    const followings = computed(() => store.state.user.followedUserIds || [])
    const subordinates = computed(() => store.state.user.departmentUserIds)
    const uid = computed(() => store.state.user.uid)
    const isManager = computed(() =>
      store.state.user.isAdmin ||
      store.state.user.isHrbp ||
      store.state.user.isHrd
    )

    const isHrbp = computed(() =>
      store.state.user.isHrbp ||
      store.state.user.isHrd
    )

    const myTeamOkrWeekParams = computed(() => uid.value === UID
      ? {
          userId: TEAM_LEADER_UID
        }
      : {})

    function toggleCollapsed () {
      store.commit(TOGGLE_SIDE_MENU_COLLAPSED)
    }

    return {
      selectedKeys,
      openKeys,
      isCollapsed,
      superiors,
      subordinates,
      followings,
      isManager,
      toggleCollapsed,
      UID,
      uid,
      myTeamOkrWeekParams,
      isHrbp
    }
  }
}
</script>

<style lang="less" scoped>
.left-sider {
  position: fixed;
  left: 0;
  top: 48px;
  z-index: 10;
  overflow: auto;
  height: calc(100vh - 48px);
  background-color: #fff;
  box-shadow: 0 0 4px 0 rgba(61, 74, 193, 0.14);
}

:deep(.ant-menu-item-icon) {
  display: block;
  font-size: 20px !important;
}

:deep(.ant-menu-title-content), .menu-item {
  display: flex;
  align-items: center;
}

.collapse-btn {
  position: fixed;
  bottom: 16px;
  left: 16px;
}

.icon {
  font-size: 20px;
}
</style>
